// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTimeline-ListItem_cls1__k16QL","cls2":"VeloTimeline-ListItem_cls2__pqdF4 VeloTimeline-ListItem_cls1__k16QL"};